export default __webpack_public_path__ + "static/media/paymentBackgroundMobile.b226978b.png";